import React from 'react'

export function McqAnswerForm({ q, answer, onChange }) {
  const choices = Array.isArray(q.payload?.choices) ? q.payload.choices : []
  const selectedIndex = typeof answer?.selectedIndex === 'number' ? answer.selectedIndex : null

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      {choices.map((c, idx) => (
        <label
          key={idx}
          style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}
        >
          <input
            type="radio"
            checked={selectedIndex === idx}
            onChange={() => onChange(q, { selectedIndex: idx })}
          />
          <span>{c || `خيار ${idx + 1}`}</span>
        </label>
      ))}
    </div>
  )
}
